import { getAgGridColId, useDefaultColumns, type Column, type ColumnDef, type CustomerTransaction } from '@talos/kyoko';
import { useMemo } from 'react';
import type { CustomerTransactionsColumn } from './types';

export const useCustomerTransactionColumns = (defaultColumns: CustomerTransactionsColumn[]) => {
  const columnDefinitions = useMemo(() => {
    return new Map<string, Column>(
      (
        [
          { type: 'date', field: 'Timestamp', initialWidth: 200, sortable: true, initialSort: '-' },
          { type: 'date', field: 'TransactTime', initialWidth: 200, title: 'Transaction Time', initialHide: true },
          { type: 'customer', field: 'Counterparty', title: 'Customer', initialWidth: 200 },
          { type: 'marketAccountSourceAccountID', field: 'MarketAccount' },
          { type: 'currency', field: 'Currency', initialWidth: 150, params: { colorful: true } },
          { type: 'size', field: 'Quantity', params: { currencyField: 'Currency' }, initialWidth: 150 },
          { type: 'transactionType', field: 'TransactionType', initialWidth: 150, title: 'Type' },
          { type: 'transferStatus', field: 'Status', initialWidth: 225 },
          { type: 'text', field: 'Initiator', initialWidth: 225, initialHide: true },
          { type: 'text', field: 'InitiatorUser', initialWidth: 225, initialHide: true },
          { type: 'text', field: 'Comments', initialWidth: 200, title: 'Comment', initialHide: true },
          { type: 'text', field: 'ExternalComments', title: 'External Comment' },
          { type: 'text', field: 'TransactionID', initialHide: true },
          { type: 'text', field: 'CustomerAddressID', initialHide: true },
        ] satisfies ColumnDef<CustomerTransaction>[]
      ).map(c => [getAgGridColId(c), c])
    );
  }, []);

  return useDefaultColumns(defaultColumns, columnDefinitions);
};
